import { InjectionToken } from '@angular/core';

export const DEFAULT_TRANSLATIONS_PATH = new InjectionToken<string>(
  'DEFAULT_TRANSLATIONS_PATH'
);
